import React, { useState } from 'react'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import { HTTP } from '../../api/resources';

export default function Imports({ donorTitle, beneficiaryTitle}) {
  const [isNewImport, setIsNewImport] = useState(true)
  const [saving, setSaving] = useState(false)

  const newImport = async () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.csv';
    fileInput.multiple = false;
    fileInput.addEventListener('change', handleFileSelect);
    fileInput.click();
  }

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    
    if (isNewImport) processNewImport(file)
    if (!isNewImport) processUpdateImport(file)
  }

  const processUpdateImport = async (file) => {
    setSaving(true)

    try {
      await updateRequest(file)
      Alert.show('notice', 'Upload successful, we will notify you once the CSV has been processed')
      setSaving(false)
    } catch {
      Alert.show('error', 'Unable to upload CSV, please try again later')
      setSaving(false)
    }
  }

  const processNewImport = async (file) => {
    setSaving(true)

    try {
      await createRequest(file)
      Alert.show('notice', 'Upload successful, we will notify you once the CSV has been processed')
      setSaving(false)
    } catch {
      Alert.show('error', 'Unable to upload CSV, please try again later')
      setSaving(false)
    }
  }

  const createRequest = (file) => {
    const formData = new FormData();
    formData.append('csv', file);
    return HTTP.post('/imports', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  const updateRequest = (file) => {
    const formData = new FormData();
    formData.append('csv', file);
    return HTTP.patch('/imports', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  return (
    <div>
      <div className='card'>
        <div className='card-header flex-header'>
          <div>
            <h4>User Imports</h4>
            <div>
              <ToggleSwitch
                small
                id="is_new_import"
                checked={isNewImport}
                onChange={checked => {
                  setIsNewImport(checked)
                }}
              />
              <label htmlFor="is_new_import">{ isNewImport ? 'New User' : 'Update User'} Import</label>
            </div>
          </div>
          <div>
            <button onClick={newImport} className='btn btn-primary' disabled={saving}>Upload CSV</button>
          </div>
        </div>
        
        {isNewImport &&
          <div className='card-body'>
            <div className='row'>
              <div className='form-group'>
                <h4 style={{ textDecoration: 'underline' }}>New User Imports</h4>
                <p>
                  New user imports allows you to mass create new { donorTitle.toLowerCase() } and { beneficiaryTitle.toLowerCase() } by uploading a CSV document containing the 
                  data you want to use to create the users. Follow the instructions below to know how to structure your CSV
                </p>

                <h4 style={{ textDecoration: 'underline' }}>Instructions</h4>
                <ol>
                  <p>1. Create a CSV file for your { donorTitle.toLowerCase() } and { beneficiaryTitle.toLowerCase() } imports</p>
                  <p>2. Create an <b>ID</b> column, this column should contain ID for each row, you can use a simple number system like 1, 2, 3, 4...</p>
                  <p>3. Create a <b>USER TYPE</b> column, this column should contain the user type of each user, available options are <b>donor</b> and <b>beneficiary</b> <i>(required)</i></p>
                  <p>4. Create a column for the default fields, the available default fields are <b>FIRST NAME, LAST NAME, USERNAME, EMAIL, BIRTHDAY, BIO</b> <i>(first name is required)</i></p>
                  <p>5. If you want to use custom fields, create the custom field on Clarity and simply create a column with the name as header in uppercase e.g <b>SCHOOL, ADDRESS</b></p>
                  <p>6. Order your CSV such that { donorTitle.toLowerCase() } with the USER TYPE <b>donor</b> comes first before { beneficiaryTitle.toLowerCase() } with USER TYPE <b>beneficiary</b></p>
                  <p>
                    7. If you want to link a { donorTitle.toLowerCase() } and a { beneficiaryTitle.toLowerCase() } together, create a <b>SPONSORSHIP</b> column and add 
                    the { beneficiaryTitle.toLowerCase() } ID to the <b>SPONSORSHIP</b> column of the { donorTitle.toLowerCase() } <i>( to link multiple, seperate value by commas 1, 2, 3, 4 )</i>
                  </p>
                  <p>8. Upload the CSV using the <b>Upload CSV</b> button, the import will start and can take between a couple minutes to an hour, we will email you once it is done</p>
                </ol>
              </div>
            </div>

            <div className='row'>
              <div className='form-group'>
                <p><i><b>NOTE:</b> It is important to ensure the ID for each row are different, the column headers are different and the column headers are all in uppercase letters</i></p>
              </div>
            </div>
          </div>
        }

        {!isNewImport &&
          <div className='card-body'>
            <div className='row'>
              <div className='form-group'>
                <h4 style={{ textDecoration: 'underline' }}>Update User Imports</h4>
                <p>
                  Update user imports allows you to mass update existing { donorTitle.toLowerCase() } and { beneficiaryTitle.toLowerCase() } fields by uploading a CSV document containing the
                  data you want to update. Follow the instructions below to know how to structure your CSV
                </p>

                <h4 style={{ textDecoration: 'underline' }}>Instructions</h4>
                <ol>
                  <p>1. Go to the reports page of the user type you want to import, select <b>IMPORT ID</b> and any other fields or custom fields you want to update and download</p>
                  <p>2. You can edit values for all columns both custom and default fields e.g <b>FIRST NAME, LAST NAME, SCHOOL</b> etc but you should not edit <b>IMPORT ID</b> values</p>
                  <p>5. Upload the CSV using the <b>Upload CSV</b> button, the import will start and can take between a couple minutes to an hour, we will email you once it is done</p>
                </ol>
              </div>
            </div>

            <div className='row'>
              <div className='form-group'>
                <p><i><b>NOTE:</b> The fields supported include <b>FIRST NAME, LAST NAME, EMAIL, USERNAME, BIRTHDAY, BIO</b>, you can also add custom fields that where created for the user type</i></p>
              </div>
            </div>
          </div>
        }
      </div>

      <div className='card'>
        <div className='card-header flex-header'>
          <h4>Value Type Instructions</h4>
        </div>

        <div className='card-body'>
          <div className='row'>
            <div className='form-group'>
              <p>
                The value type instructions below will help you understand how to structure your CSV for the different custom field types available on Clarity
              </p>

              <p>
                1. <b>Date: </b> The date should be in the format <i>YYYY-MM-DD</i> e.g <i>2020-12-31</i> 
              </p>
              <p>
                2. <b>Text or Long Text: </b> The text should be a string of characters e.g <i>John Doe</i>
              </p>
              <p>
                3. <b>Link: </b> The link should be a valid URL e.g <i>https://www.google.com</i>
              </p>
              <p>
                4. <b>Select: </b> The value should be written as a string e.g <i>United States </i> 
                but the value must already be an option for the field
              </p>
              <p>
                5. <b>Dynamic: </b> The value should be written as a string with the date 
                <i> Class 1 (YYYY-MM-DD)</i>, if you want multiple values, separate them with a 
                comma <i>Class 1 (YYYY-MM-DD), Class 2 (YYYY-MM-DD)</i>. Commas should only be 
                used for multiple values and brackets should only be used for dates. 
                Both date and text is required for each value 
              </p>
              <p>
                6. <b>USER TYPE: </b> This field should contain the user type of the user, 
                available options are <b>donor</b> and <b>beneficiary</b> and should only 
                be used for new imports ( required ), not update imports 
              </p>
              <p>
                7. <b>ID: </b> This is required and should only be used for new imports, 
                we recommend using a unique number for each row. This field should not be
                used for update imports
              </p>
              <p>
                8. <b>SPONSORSHIP: </b> This field should contain the IDs of the { beneficiaryTitle.toLowerCase() } the { donorTitle.toLowerCase() } is
                sponsoring, you can seperate the values by commas e.g 1, 2, 3, 4 this field should only be used for new imports. 
                If you are going to be using this field, ensure the { donorTitle.toLowerCase() } comes first
                before the { beneficiaryTitle.toLowerCase() } in the CSV
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
